module.exports = require("require-in-the-middle");